<template>
  <div>
    <v-btn
      @click="handleSignout"
      rounded="xl"
      class="logout-button"
    >
      <v-icon icon="mdi-logout"></v-icon>
    </v-btn>
  </div>
</template>

<style scoped>
.v-btn {
    border-radius: 50% !important;
    min-width: 2.25rem !important;
    width: 2.25rem !important;
    height: 2.25rem !important;
}
.logout-button {
    background-color: #1A1615 !important;
    color: #ffffff !important;
}
</style>

<script>
import { getAuth, signOut } from "firebase/auth";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth_store";

export default {
  name: "AccountToggle",
  props: {
    displayLogout: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const router = useRouter();
    const auth = getAuth();
    const authStore = useAuthStore();

    const handleSignout = () => {
      signOut(auth)
        .then(() => {
          router.push("/welcome");
        })
        .catch((error) => {
          console.error(error);
        });
    };

    return {
      handleSignout,
      authStore,
    };
  },
};
</script>
